import { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login  from './components/Login';
import Acervo from './components/Acervo';
import PdfViewer from './components/PdfViewer';
import './index.css';

export default function App() {
  const [user, setUser] = useState(null);

  if (!user) {
    return <Login onLogin={setUser} />;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/"        element={<Acervo user={user} onLogout={() => setUser(null)} />} />
        <Route path="/pdf/*"   element={<PdfViewer user={user} onLogout={() => setUser(null)} />} />
        <Route path="*"        element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}
